import ActionModal from "./ActionModal";
import {Button, message, Modal, notification, Space} from "antd";
import React, {useContext, useEffect, useState} from "react";
import {delay, pick} from "lodash";
import {ClientBridge} from "../index";
import {AppController} from "../App";
import {downloadBlob, downloadUrl, replaceElement, tryNTimes} from "../Wizard/utils";
import ShareAction, {getEmailRequest} from "./ShareAction";
import QuarkRender from "../services/quarkRender";
import {getSpecAdFileName, inchesToPixels} from "../lib/Utils";
import {useModel} from "../model/modelHooks";
import {SubscribeMessage} from "../uiUtils/SubscribeMessage";
import {getRenderRequest} from "../render/SpecAdRender";
import {CopyOutlined, DownloadOutlined} from "@ant-design/icons";


export function SpecAdAction(
    {
        action, onActionDone =()=>{},
        advertiser, advSsResults={},
        salesSheet,  // current salesSheet
        specAd, changes,
        getPdfUrl, getNewSpecAd, onSave,
        assetAuth,
        ...props
    })
{
    const {model, mcc} = useContext(ClientBridge);
    const [quarkRender] = useState(() => new QuarkRender({
        baseURL: mcc.quarkRenderServer
    }));
    const loginPerson = useModel(model, 'person', 'selected_login', {one: true});

    //const [query, setQuery] = useState({});
    //const { data:{records: advSsList, total}={}, setAdvSs} = useAodSearch(query,'salesSheet');
    const { data:{records: advSsList=[], total=0}={}, setData: setAdvSs} = advSsResults;
    const controller = useContext(AppController);

    const [shareAction, setShareAction] = useState();
    const [shareInfo, setShareInfo] = useState();

    /*
    useEffect(()=>{
        if (advertiser && !specAd) {
            // don't bother kicking of request unless we are saving
            setQuery({
                searchBy: 'advertiser',
                id: advertiser.id
            });
        }
    },[advertiser, specAd]);
     */

    const onFinish = async ({saveAction='', ...values}={})=>{

        const saveNeeded = saveAction.startsWith('Save');

        // todo
        // SpecAd + Save - update
        // SpecAd + Save As - copy
        if (saveAction === 'Save As') {
            try {
                const {jobNumber, text} = values;
                const {newSalesSheet, salesSheet: selectedSalesSheet, name, notes} = values;
                //const saveToSalesSheet = newSalesSheet ? {name, notes} : selectedSalesSheet;
                let saveToSalesSheet = selectedSalesSheet;

                const pdfUrl = await getPdfUrl();
                const newSpecAd = await getNewSpecAd();
                newSpecAd.jobNumber = jobNumber;
                newSpecAd.notes = text;
                newSpecAd.locked = action!=='Save As';  //i.e. with Download or Share

                if (newSalesSheet)  {
                     const emptySalesSheet = {name, notes};
                    // todo ? note working only for SOLD ADS
                    //salesSheet = await controller.createSalesSheet(emptySalesSheet,advertiser,
                    //    {specAd:newSpecAd, pdfUrl});
                    //specAd = salesSheet.specAds[0];

                    saveToSalesSheet = await controller.createSalesSheet(emptySalesSheet,advertiser);
                    const newData = {
                        records:[saveToSalesSheet, ...advSsList],
                        total: total+1
                    };
                    setAdvSs(newData);  // refresh here in case createSpecAd fails
                }

                specAd = await controller.createSpecAd(newSpecAd, saveToSalesSheet, pdfUrl);
                // todo this is cheating... ? or just call make a 3rd call
                saveToSalesSheet.specAds.unshift(specAd);
                saveToSalesSheet.recordVersion = saveToSalesSheet.recordVersion+.001;
                //todo ? force another refresh - setAdvSs(newData);

                if (onSave){
                    delay(()=>onSave({salesSheet: saveToSalesSheet, specAd}),0);
                }

            } catch (e) {
                notification.error({message:'Save ad failed', description:e.message});
                throw e;
            }
        }
        if (saveAction === 'Save') {
            try {
                const {jobNumber, text} = values;
                const pdfUrl = await getPdfUrl();

                const adChanges = await getNewSpecAd();
                adChanges.jobNumber = jobNumber;
                adChanges.notes = text;
                if (!action.startsWith('Save')) {
                    adChanges.locked = true;  //i.e. with Download or Share
                }

                specAd = await controller.updateSpecAd(specAd, adChanges, pdfUrl);
                // todo this is cheating... ? or just call make a 3rd call
                replaceElement(salesSheet.specAds, specAd);
                salesSheet.recordVersion = salesSheet.recordVersion+.001;
                //todo ? force another refresh - setAdvSs(newData);

                if (onSave){
                    delay(()=>onSave({salesSheet, specAd}),0);
                }

            } catch (e) {
                notification.error({message:'Save ad failed', description:e.message});
                throw e;
            }
        }


        switch (action){
            case 'Download':
                try {
                    //await downloadUrl(specAd.originalUrl, 'Spec Ad');
                    await tryNTimes({toTry:()=>downloadUrl(specAd.originalUrl, 'Spec Ad'), times:3});
                } catch (e) {
                    notification.error({message:'Download failed', description:e.message});
                    throw e;
                } finally {
                    onActionDone();
                }
                break;
            case 'Download JPEG':
                try {
                    //await downloadImage(specAd);
                    await tryNTimes({toTry:()=>downloadImage(specAd), times:3});
                } catch (e) {
                    notification.error({message:'Download failed', description:e.message});
                    throw e;
                } finally {

                }
                break;
            case 'Email Link':
            case 'View Link':
                //todo ?roll up in single server call
                try {
                    //ensure we have a qxp
                    const renderResult = await quarkRender.render(getRenderRequest(
                        pick(specAd.renderInfo,'template', 'overlay', 'output', 'adContent', 'socialMedia'),
                        {format: "qxp"}
                    ))

                    //Create Zip
                    const gatherResult = await quarkRender.gather(getGatherRequest(specAd))
                    //todo ?error trap

                    //Send email with Zip link
                    const filename = getSpecAdFileName(specAd,'zip')
                    const zipUrl = gatherResult.remoteUrl+'?filename='+filename

                    if (action==='Email Link') {
                        try {
                            await quarkRender.email(getEmailRequest({
                                formInfo: values,
                                zipUrl,
                                specAd,
                                advertiser
                            }))

                            message.info('Email sent');
                        } catch (e) {
                            console.error(e);
                            message.error('Email failed');
                        } finally {
                            onActionDone()
                        }
                    } else {
                        Modal.info({
                            title: 'Production files',
                            content: <div>
                                <Space direction={'horizontal'}>
                                    <Button icon={<CopyOutlined />} onClick={copy} type={'primary'}>Copy link</Button>
                                    <Button icon={<DownloadOutlined/>} href={zipUrl} type={'primary'}>Download</Button>
                                </Space>
                                <p/>
                                <textarea id='copyTarget' readOnly={true}
                                      rows={4}
                                      cols="40"
                                      defaultValue={zipUrl}/>
                                <div style={{display:'none'}}><input id='empty' /></div>
                            </div>,
                            afterClose: onActionDone
                        })
                    }
                } catch (e) {
                    console.error(e);
                    message.error('Gathering production files failed');
                    onActionDone()
                }
                break
            case 'PDF':
            case 'Email':
            case 'Print':
                setShareInfo({
                    formInfo:values,
                    specAd,
                    advertiser,
                    saveNeeded
                });
                setShareAction(action);
                break;
            case 'Save':
            case 'Save As':
                // ... already done
                onActionDone();
                break;
            default:
                console.error('!Unknown action: '+action);
                onActionDone();
        }

        if ( ! (specAd.locked || action.startsWith('Save') )) {
            const lockedAd = await controller.lockSpecAd(specAd);
            // tad clugy... ? could this still be the same one
            //const updatedSalesSheet = model.salesSheet.get(salesSheet.id);
            if (onSave){
                onSave({ specAd:lockedAd});
            }
        }
    };


    async function downloadImage(specAd, format='jpg') {

        const {previewUrl: url, renderInfo} = specAd;
        const {width: widthInches, height: heightInches} = renderInfo.output;
        const fileName = getSpecAdFileName(specAd,format)

        const blob = await quarkRender.convert({
            width: inchesToPixels(widthInches),
            height: inchesToPixels(heightInches),
            format, url, fileName
        });
        await downloadBlob(blob, fileName);
    }

    const onFinishFailed = ({values, errorFields, outOfDate}) => {
        //todo ? do we need to spot & report errors other than form failures
        //message.error('Failed!');
    };

    const getInitialValues = ()=>{

        const isSave = action.startsWith('Save');
        const saveNeeded =  !specAd || changes || isSave;
        let saveAction;

        if (saveNeeded) {
            if (isSave) {
                saveAction = action;  // do as they ask (new ads won't be 'Save')
            } else if (changes && !specAd.locked) {
                saveAction = 'Save';
            } else {
                saveAction = 'Save As';  // encourage locked ads to not be updated
            }
        }

        return {
            salesSheet,
            newSalesSheet: advSsList.length === 0,
            saveAction,
            ...getShareDefaults({specAd, advertiser, loginPerson}),
            ...getMailFormDefaults({advertiser, loginPerson, action})
        };
    }

    // tab clarty - need to not run action during render
    useEffect(()=> {
        if (action) {
            if (action.startsWith('Download') && specAd && !changes) {
                onFinish();
            }
            /*
            // Show dialog anyway
            if (action === 'Save') {
                onFinish(getInitialValues());
            }
             */
        }
    }, [action]);

    // avoid short cut actions above
    const showModal = action &&
        assetAuth === true &&
        ! (action.startsWith('Download') && specAd && !changes) ;
        // && ! (action === 'Save');

    return <>
        <Modal
            visible={action && assetAuth !== true}
            title={'MiAD Wizard Subscription required'}
            onCancel={onActionDone}
            footer={[
                <Button onClick={onActionDone} type={'primary'} key={'OK'}>OK</Button>
            ]}
        >
            <SubscribeMessage/>
        </Modal>
        {showModal &&
            <ActionModal
                {...{advertiser, salesSheet, specAd, action, advSsList, changes}}
                visible={!!action} onCancel={onActionDone}
                formProps={{
                    onFinish,
                    onFinishFailed,
                    initialValues: getInitialValues()
                }}
                {...props}
            />}
        {shareAction && <ShareAction shareInfo={shareInfo}
                         shareAction={shareAction}
                         onShareDone={()=>{
                             setShareAction();
                             onActionDone();
                         }}
            />}
    </>
}

export function SalesSheetAction(
    {
        action, onActionDone = ()=>{},
        advertiser, salesSheet,
        ...props
    })
{
    const {model} = useContext(ClientBridge);
    const loginPerson = useModel(model, 'person', 'selected_login', {one: true});
    const [shareAction, setShareAction] = useState();
    const [shareInfo, setShareInfo] = useState();

    const onFinish = async values=>{

        setShareInfo({
            formInfo:values,
            salesSheet,  // todo ? current one in form could be different
            advertiser,
        });
        setShareAction(action);
    };

    const onFinishFailed = ({values, errorFields, outOfDate}) => {
        //todo ? do we need to spot & report errors other than form failures
        //message.error('Failed!');
    };

    const getInitialValues = ()=>{
        return {
            salesSheet,
            ...getSalesSheetShareDefaults({salesSheet, advertiser, loginPerson}),
            ...getMailFormDefaults({advertiser, loginPerson, action})
        };
    }

    return <>
        {action &&
            <ActionModal
                {...{advertiser, salesSheet, action}}
                target={'salesSheet'}
                visible={!!action} onCancel={onActionDone}
                formProps={{
                    onFinish,
                    onFinishFailed,
                    initialValues: getInitialValues()
                }}
                {...props}
            />}
        {shareAction &&
            <ShareAction
                target={'salesSheet'}
                shareInfo={shareInfo}
                shareAction={shareAction}
                onShareDone={()=>{
                     setShareAction();
                     onActionDone();
                }}
        />}
    </>
}

// setShareAction(a=>a==='Print'?'done':undefined);

function getSalesSheetShareDefaults({salesSheet, advertiser={}, loginPerson}) {
    const {jobNumber, notes, name} = salesSheet;
    const subject = 'Presentation ' + name + ' ' +
        (jobNumber ? jobNumber : '') +
        (jobNumber && advertiser ? ', ' : '') +
        (advertiser ? "\n" + advertiser.name : '');

    const text = notes || 'This presentation has been prepared for you.';
    const creator = loginPerson.firstName + ' ' + loginPerson.lastName;
    const adCount = salesSheet.specAds.length;
    const columns =
        adCount <= 1 ? 1 :
            adCount <= 4 ? 2 :
                adCount <= 9 ? 3 :
                    adCount <= 16 ? 4 :
                        adCount <= 18 ? 3 : 4; // 2 pages anyway

    return {
        jobNumber, subject, text, creator,
        columns
    };
}

function getShareDefaults({specAd={}, advertiser={}, loginPerson}) {
    const {jobNumber, notes} = specAd;
    const subject = 'Spec Ad ' +
        (jobNumber ? jobNumber : '') +
        (jobNumber && advertiser ? ', ' : '') +
        (advertiser ? "\n" + advertiser.name : '');

    const text = notes || 'This spec ad has been prepared for you.';
    const creator = loginPerson.firstName + ' ' + loginPerson.lastName;

    return {jobNumber, subject, text, creator};
}

function getMailFormDefaults({advertiser, loginPerson, to='', action}) {

    if (!to && advertiser) {
        if (advertiser.contact) {
            to = advertiser.contact.email;
        } else {
            to = advertiser.email;
        }
    }

    return {
        fromName: loginPerson.firstName + ' ' + loginPerson.lastName,
        replyTo: loginPerson.email,
        bccReplyTo: true,
        to
    };
}


function getGatherRequest(specAd)
{
    const {overlay, template} = specAd.renderInfo
    return {
        template: template.file_base,
        overlays: (overlay.file || overlay.aodAsset) ? [overlay] : [],
        output: {format:'zip'}, // ? redundant
        specAd: pick(specAd, 'jobNumber','metroReference')
    };
}

function copy({targetId='copyTarget',afterId='empty'}) {
    document.querySelector("#"+targetId).select()
    document.execCommand("copy");
    document.querySelector("#"+afterId).select()
}
